import styled from 'styled-components/macro';

export const MakeStatus = styled.p`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
`;
